import { Typography } from "@mui/material";
import { ROUTE_PATHS } from "../../routes/route-paths";
import { IMAGES_PATH } from "../../constants";

function Logo({ color = "#FFFFFF" }) {
  const onLogoClick = () => {
    window.location.href = ROUTE_PATHS.EXTERNAL_WEBSITE_LINK;
  };

  return (
    <img
      src={
        IMAGES_PATH +
        (color === "black" || color === "#000000"
          ? "/logo-black.png"
          : "/logo.png")
      }
      alt="Logo"
      width="150px"
      height="100%"
      onClick={onLogoClick}
      style={{ cursor: "pointer" }}
    />
  );
}

export { Logo };
